import {presets} from "../../../babel.config";

export default {
    actions: {
        toggleAllLoc: function ({commit, getters}) {
            if (!getters.allLocActive) {
                commit('fullActiveCabinLoc');
            }
        },
        toggleActiveCabinLoc: function ({commit, getters}, data) {
            if (getters.isActiveCabinLoc(data)) {
                if (getters.isLastActiveCabinLoc) {
                    commit('fullActiveCabinLoc');
                } else {
                    commit('removeActiveCabinLoc', data);
                }
            } else {
                commit('addActiveCabinLoc', data);
            }
        },
        autoSetCheckedGroupCabin: function ({commit, getters}) {
            let result = [];
            for (let groupId in getters.listCabinGroup) {
                if (!result[getters.listCabinGroup[groupId].ID]) {
                    result[getters.listCabinGroup[groupId].ID] = [];
                }
                for (let cabinId in getters.listCabin) {
                    if (+getters.listCabin[cabinId].cabin_grp_id === +getters.listCabinGroup[groupId].ID && !result[getters.listCabinGroup[groupId].ID].length) {
                        result[getters.listCabinGroup[groupId].ID] = +getters.listCabin[cabinId].ID;
                    }
                }
            }
            commit('setCheckedGroupCabin', result);
        }
    },
    mutations: {
        setActiveDiscountId: function (state, discountId) {
            state.activeDiscountId = +discountId;
        },
        setCheckGroupCabin: function (state, {groupId, cabinId}) {
            state.listCheckedGroupCabin[+groupId] = +cabinId;
            state.listCheckedGroupCabin = JSON.parse(JSON.stringify(state.listCheckedGroupCabin));
        },
        setCheckedGroupCabin: function (state, data) {
            if (data) {
                state.listCheckedGroupCabin = JSON.parse(JSON.stringify(data));
            }
        },
        addTariffCount: function (state, data) {
            let tariff = state.listCabinTariff.find(item => item.ID == data);
            tariff.count++;
        },
        removeTariffCount: function (state, data) {
            let tariff = state.listCabinTariff.find(item => item.ID == data);
            return tariff.count >= 1 ? tariff.count-- : 0;
        },
        fullActiveCabinLoc: function (state) {
            state.activeCabinLoc = Object.values(state.listCabinLoc).map(loc => +loc.ID);
        },
        setListCabin: function (state, data) {
            state.listCabin = data;
        },
        setListCabinPrice: function (state, data) {
            state.listCabinPrice = data;
        },
        setListCabinGroup: function (state, data) {
            if (typeof data) {
                state.listCabinGroup = Object.values(data)
            } else {
                state.listCabinGroup = data;
            }
        },
        setListCabinDiscount: function (state, data) {
            state.listCabinDiscount = data;
        },
        setListCabinTariff: function (state, data) {
            state.listCabinTariff = data.map(item => {
                item.count = 0;
                return item;
            });
        },
        setListCabinLoc: function (state, data) {
            state.listCabinLoc = data;
        },
        addActiveCabinLoc: function (state, data) {
            if (state.activeCabinLoc.indexOf(data) === -1) {
                state.activeCabinLoc.push(data);
            }
        },
        removeActiveCabinLoc: function (state, data) {
            const index = state.activeCabinLoc.indexOf(data);
            if (index !== -1) {
                state.activeCabinLoc.splice(index, 1);
            }
        },
        setCapacity: function (state, data) {
            state.capacity = data;
        }
    },
    getters: {
        activeCabinDiscount: (state) => {
            console.log(state.listCabinDiscount)
            if (state.listCabinDiscount) {
                return state.listCabinDiscount.find(item => +item.ID === state.activeDiscountId)
            }
            return null;
        },
        listCabin: (state) => state.listCabin,
        listCabinDiscount: (state) => state.listCabinDiscount,
        listCabinFilterByCapacity: (state) => state.listCabin.filter(cabin => +cabin.capacity >= state.capacity),
        listCabinPrice: (state) => state.listCabinPrice,
        listCabinGroup: (state) => state.listCabinGroup,
        listCabinGroupByLoc: (state) => locId => state.listCabinGroup.filter(item => +item.cabin_loc_id === +locId),
        listCabinCabinByLoc: (state) => locId => state.listCabin.filter(item => ((+item.cabin_loc_id === +locId) && (+state.capacity <= +item.capacity))),
        listCabinTariff: (state) => state.listCabinTariff,
        listCabinLoc: (state) => state.listCabinLoc,
        listCabinByGroup: (state, getters) => groupId => getters.listCabinFilterByCapacity.filter(cabin => +cabin.cabin_grp_id === +groupId),
        listCheckedGroupCabin: (state) => state.listCheckedGroupCabin,
        listCabinTariffByCabin: state => cabinId => state.listCabinTariff.filter(tariff => +tariff.cabin_id === +cabinId),
        isActiveCabinLoc: state => id => state.activeCabinLoc.indexOf(+id) === -1 ? false : true,
        isActiveCabinGroup: (state, getters) => id => {
            if (!getters.listCabinByGroup(id).length) {
                return false;
            }
            const group = getters.getGroupById(id);
            return getters.isActiveCabinLoc(group.cabin_loc_id);
        },
        isLastActiveCabinLoc: state => state.activeCabinLoc.length === 1,
        allLocActive: state => Object.values(state.listCabinLoc).length === state.activeCabinLoc.length,
        getGroupById: state => groupId => state.listCabinGroup.find(group => group.ID === groupId),
        getCabinById: state => cabinId => state.listCabin.find(cabin => +cabin.ID === +cabinId),
        getPriceByCabinTariff: (state, rootGetters) => (cruiseId, tariffId, count) => {
            let result;
            let course = +rootGetters.getCourse;
            let price = state.listCabinPrice.find(price => +price.cruise_id === +cruiseId && +price.tariff_id === +tariffId);

            if (price && price.value) {
                if (course == 1) {
                    result = !!count ? price.value * count : price.value
                    // result = rootGetters.getPriceWithDiscount(cruiseId, tariffId, result);
                } else {
                    result = !!count ? Math.trunc(price.value * count * course) : Math.trunc(price.value * course)
                    // result = rootGetters.getPriceWithDiscount(cruiseId, tariffId, result);
                }
            }
            return result;
        },
        getPriceWithDiscount: (state, getters) => (cruiseId, tariffId, cost) => {
            if (getters.activeCabinDiscount) {
                if (getters.activeCabinDiscount.tariff_ID === null || +getters.activeCabinDiscount.tariff_ID === +tariffId) {
                    cost = cost - (cost / 100) * getters.activeCabinDiscount.discount_price;
                }
            }
            return cost;
        },
        getPriceByCabinTariffCourse: (state, rootGetters) => (cruiseId, tariffId, count) => {
            let price = state.listCabinPrice.find(price => +price.cruise_id === +cruiseId && +price.tariff_id === +tariffId);
            let course = +rootGetters.getCourse;

            if (price && price.value) {
                if (course == 1) {
                    return null
                } else {
                    return !!count ? Math.trunc(price.value) * count : Math.trunc(price.value)
                }
            }
            return;
        },
        getCabinCostFrom: (state, rootGetters) => cabinId => {
            let minPrice = rootGetters.listCabinTariffByCabin(cabinId).reduce((res, cur) => {
                let price = rootGetters.getPriceByCabinTariff(rootGetters.cruiseId, cur.ID, 0);
                return (price < res) ? price : res;
            }, +Infinity);

            if (minPrice == +Infinity) return '-';
            return minPrice;
        },
        getCabinCostFromCourse: (state, rootGetters) => cabinId => {
            let course = +rootGetters.getCourse;
            let minPrice = rootGetters.listCabinTariffByCabin(cabinId).reduce((res, cur) => {
                let price = rootGetters.getPriceByCabinTariffCourse(rootGetters.cruiseId, cur.ID, 0);
                return (price < res) ? price : res;
            }, +Infinity);

            if (minPrice == +Infinity) return '-';

            if (course == 1) {
                return null
            } else {
                return Math.trunc(minPrice);
            }
            // return minPrice;
        },
        getCabinCostBasket: (state, rootGetters) => cabinId => {
            return rootGetters.listCabinTariffByCabin(cabinId).reduce((res, cur) => {
                if (cur.count) {
                    let price = rootGetters.getPriceByCabinTariff(rootGetters.cruiseId, cur.ID, cur.count);
                    res += price;
                }
                return res;
            }, 0);
        },
        getCabinCostBasketCourse: (state, rootGetters) => cabinId => {
            let price = rootGetters.getCabinCostBasket(cabinId);
            let course = +rootGetters.getCourse;
            if (price) {
                if (course == 1) return null;
                else
                    return Math.trunc(price);
            }
        },
        getCheckedGroupCabin: state => groupId => state.listCheckedGroupCabin[groupId]
    },
    state: {
        listCabin: [],
        listCabinDiscount: [],
        listCabinPrice: [],
        listCabinGroup: [],
        listCabinTariff: [],
        listCabinLoc: [],
        activeCabinLoc: [],
        activeDiscountId: null,
        checkedGroupCabin: [],
        listCheckedGroupCabin: [],
        capacity: 1,
    },
};
